'use strict';

app.controller('LinkCtrl', [
    '$scope',
    '$http',
    '$translate',
    '$state',
    '$ngConfirm',
    'toaster',
    function($scope, $http, $translate, $state, $ngConfirm, toaster) {
        /*
         *  Form data
         */

        $scope.loading = false;

        $scope.SHARE_TYPE_OBJECTS = 1;
        $scope.SHARE_TYPE_GROUP = 2;

        $scope.objects = angular.copy($scope.extractObjectsBySelectedGroup(false, false));

        $scope.selected = {
            type: $scope.SHARE_TYPE_OBJECTS,
            object: null,
            objects: [],
            group_id: null,
            date_start: moment()
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss'),
            date_end: moment()
                .add(7, 'days')
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss'),
            walter: false,
            speditor: false,
        };
        $scope.selectedInit = angular.copy($scope.selected);

        $scope.linkReady = true;
        $scope.generatedLink = '';
        $scope.generatedLinkShow = false;

        $scope.showByShareType = function(type) {
            return $scope.selected.type === type;
        };

        /*
         *  Tabs
         */

        $scope.FORM_TAB = 1;
        $scope.LIST_TAB = 2;

        $scope.tab = $scope.FORM_TAB;

        $scope.changeTab = function(v) {
            $scope.tab = v;

            if (v === $scope.LIST_TAB) {
                $scope.loadLinks();
            }
        };

        $scope.isTab = function(tab) {
            return $scope.tab === tab;
        };

        /*
         *  Links
         */

        $scope.links = [];
        $scope.loadLinks = function() {
            $scope.loading = true;

            $http.get('/api/share').then(
                function(response) {
                    $scope.loading = false;

                    $scope.links = response.data.data;
                },
                function() {
                    $scope.loading = false;

                    toaster.pop(
                        'error',
                        $translate.instant('links.toastr.error.header'),
                        $translate.instant('links.toastr.error.getlist')
                    );
                }
            );
        };

        $scope.removeObject = function(obj) {
            $scope.selected.objects = $scope.selected.objects.filter(function(o) {
                return o.objectId !== obj.objectId;
            });
        };

        $scope.addObject = function() {
            var o = JSON.parse($scope.selected.object);
            $scope.selected.objects.push(o);
        };

        $scope.validate = function(data) {
            return (
                (data.type === $scope.SHARE_TYPE_OBJECTS && data.objects.length) ||
                (data.type === $scope.SHARE_TYPE_GROUP && data.group_id)
            );
        };

        $scope.buildPayload = function(data) {
            var payload = data;
            var keys = Object.keys(payload);

            payload.objects = JSON.stringify(
                payload.objects.map(function(o) {
                    return o.objectId;
                })
            );

            for (var i in keys) {
                var key = keys[i];
                switch (payload.type) {
                    case $scope.SHARE_TYPE_GROUP:
                        ['walter', 'object', 'objects'].indexOf(key) >= 0 && delete payload[key];
                        break;
                    default:
                        ['speditor', 'object', 'group_id'].indexOf(key) >= 0 && delete payload[key];
                        break;
                }
            }

            return payload;
        };

        $scope.generate = function() {
            $scope.generatedLink = '';
            $scope.generatedLinkShow = false;

            if (!$scope.validate($scope.selected)) {
                toaster.pop(
                    'error',
                    $translate.instant('links.toastr.error.header'),
                    $translate.instant('links.toastr.error.validate')
                );
                return false;
            }

            var payload = angular.copy($scope.selected);
            payload = $scope.buildPayload(payload);

            $http.post('/api/share', { data: payload }).then(
                function(response) {
                    $scope.generatedLink = response.data.data.hash;
                    $scope.generatedLinkShow = true;

                    $scope.linkReady = true;
                    toaster.pop(
                        'success',
                        $translate.instant('links.toastr.success.header'),
                        $translate.instant('links.toastr.success.created')
                    );

                    // reset form
                    $scope.selected = angular.copy($scope.selectedInit);
                },
                function() {
                    $scope.linkReady = true;
                    toaster.pop(
                        'error',
                        $translate.instant('links.toastr.error.header'),
                        $translate.instant('links.toastr.error.created')
                    );
                }
            );
        };

        $scope.preview = function(hash) {
            var url = $state.href('preview.link', { hash: hash });
            window.open(url, '_blank');
        };

        $scope.clipboard = function(hash) {
            return $state.href('preview.link', { hash: hash }, { absolute: true });
        };

        $scope.status = function(link) {
            var enable = !link.enable;
            $http.put('/api/share/' + link.id, { data: { enable: enable } }).then(
                function(response) {
                    var changed = response.data.data.enable;
                    link.enable = changed;
                    toaster.pop(
                        'success',
                        $translate.instant('links.toastr.success.header'),
                        $translate.instant('links.toastr.success.updated')
                    );
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('links.toastr.error.header'),
                        $translate.instant('links.toastr.error.updated')
                    );
                }
            );
        };

        $scope.delete = function(link) {
            $http.delete('/api/share/' + link.id).then(
                function(response) {
                    $scope.loadLinks();
                    toaster.pop(
                        'success',
                        $translate.instant('links.toastr.success.header'),
                        $translate.instant('links.toastr.success.deleted')
                    );
                },
                function(response) {
                    toaster.pop(
                        'error',
                        $translate.instant('links.toastr.error.header'),
                        $translate.instant('links.toastr.error.deleted')
                    );
                }
            );
        };

        $scope.modals = {
            mail: {
                receiver: '',
            },
        };

        $scope.openEmailModal = function(link) {
            $ngConfirm({
                title: $translate.instant('links.modals.mail.title'),
                contentUrl: 'tpl/pages/shares/modals/mail.html',
                theme: 'supervan',
                columnClass: 'xl',
                icon: 'pe-7s-mail',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.ok'),
                        btnClass: 'btn-info',
                        action: function(scope) {
                            var payload = {
                                link: '/preview/link/' + link,
                                mail: scope.modals.mail.receiver,
                                type: 'share',
                            };

                            var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                            if (!filter.test(payload.mail)) {
                                return false;
                            }

                            scope.modals.mail.receiver = '';
                            $http.post('/api/notification/mail', payload).then(
                                function(response) {
                                    toaster.pop(
                                        'success',
                                        $translate.instant('links.toastr.success.header'),
                                        $translate.instant('links.toastr.success.mail')
                                    );
                                },
                                function() {
                                    toaster.pop(
                                        'error',
                                        $translate.instant('links.toastr.error.header'),
                                        $translate.instant('links.toastr.error.mail')
                                    );
                                }
                            );
                            return true;
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-dark',
                        action: function() {},
                    },
                },
            });
        };

        /*
         *  Init function
         */

        $scope.init = function() {};
        $scope.init();
    },
]);
